import { Button, Card, CardActions, CardContent, CardHeader, Grid, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import AdminLogIn from './AdminLogIn'
import { Route, BrowserRouter as Router, Switch, Link ,withRouter, useHistory } from 'react-router-dom'
import Admin_header from './AdminHeader'
import EditPage from './EditPage'

import AuthoProvider from './AuthProvider'

function Admin() {

    const history = useHistory();


    function loadPrijave(){
      history.push("/admin/pregled");
    }

    function loadEdit(){
      history.push("/admin/edit");
    }

    function loadRadovi(){
      history.push("/admin/predavaci");
    }


    // TODO LUCIJA PRIJEDLOG TREBA GA DORADIT
    // KAŽE DA AKO NEMA TOKEN TREBA PREBACITI NA ADMINLOGIN ROUTU I NAĆE PUŠTA GA NA ADMIN
    
      //TREBA ODRADITI
      // useEffect(() => {
        
      //   return () => {
          
      //   }
      // }, [])


    

    return (
      <AuthoProvider>
        




        <Grid
          container
          alignItems="center"
          direction="column"
          style={{ marginTop: "50px", marginBottom: "30",backgroundColor:"rgb(246,247,253)"}}
        >
          <Grid item lg={12} md={12} sm={12}>
            <Typography variant="h3">Dobrodošli u Admin</Typography>
          </Grid>
          <Grid item>
            <Typography lg={12} style={{marginBottom:"80px"}}>
              Izaberite od dolje ponuđenih opcija koje želite primijeniti.
            </Typography>
          </Grid>
        </Grid>
        
        <Grid container alignContent="center" justify="space-around" style={{backgroundColor:"rgb(246,247,253)"}} >
          <Grid item lg={3} md={3} sm={12} onClick={loadPrijave} >
            <Card style={{height:"200px",border:"2px solid #45B283"}}>
              <CardHeader
                title="Pregled gostiju"
                style={{ backgroundColor: "white",color:"#1F94C2" }}
              ></CardHeader>

              <CardContent>
                <Typography color="textSecondary" gutterBottom style={{height:"50px"}}>
                  Tablica prijavljenih i odobrenih gostiju.
                  
                </Typography>
              </CardContent>
              <CardActions>
                <Button variant="contained" color="primary" size="small"   style={{width:"100%",backgroundColor:"#1F94C2"}}>
                  Odaberi
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid item lg={3} md={3} sm={12} onClick={loadEdit}>
            <Card style={{height:"200px",border:"2px solid #45B283"}}>
              <CardHeader
                title="Uredi stranicu"
                style={{ backgroundColor: "white" ,color:"#1F94C2",fontSize:"100px"}}
              ></CardHeader>
              <CardContent>
                <Typography color="textSecondary" gutterBottom style={{height:"50px"}}>
                  Odaberite komponentu stranice koju želite urediti.
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{width:"100%",backgroundColor:"#1F94C2"}}
                >
                    Odaberi
                </Button>
              </CardActions>
            </Card>
          </Grid>
    
          <Grid item lg={3} md={3} sm={12} onClick={loadRadovi}>
            <Card style={{height:"200px",border:"2px solid #45B283"}}>
              <CardHeader
                title="Pregled predavača"
                style={{ backgroundColor: "white",color:"#1F94C2"}}
              ></CardHeader>
              <CardContent>
                <Typography color="textSecondary" gutterBottom style={{height:"50px"}}>
                Tablica prijavljenih i odobrenih predavača.
                </Typography>
              </CardContent>
              <CardActions>
                <Button variant="contained" color="primary" size="small"  style={{width:"100%",backgroundColor:"#1F94C2"}}>
                Odaberi
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      

        


      </AuthoProvider>
    );
}

export default Admin
